var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.172,
    height: 29.201,
    viewBox: "0 0 18.172 29.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2917",
    "data-name": "Rectangle 2917",
    width: 9.739,
    height: 27.53,
    fill: "#414042"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WtIcon",
    transform: "translate(8.963) rotate(19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19585",
    "data-name": "Group 19585",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M4.568,27.531c-.253-.053-.509-.092-.758-.162a3.712,3.712,0,0,1-2.63-3.15c-.028-.307-.027-.617-.027-.926q0-7.614,0-15.228a.218.218,0,0,0-.139-.233A1.75,1.75,0,0,1,.008,6.2q-.016-1.962,0-3.925A2.264,2.264,0,0,1,2.311,0q2.56,0,5.121,0a2.262,2.262,0,0,1,2.3,2.284q.011,1.949,0,3.9a1.752,1.752,0,0,1-1.051,1.66c-.095.047-.086.109-.086.183q0,3.857,0,7.715,0,4,0,8a3.73,3.73,0,0,1-2.9,3.695c-.177.043-.36.065-.54.1ZM4.854,6.314H7.811C7.984,6.314,8,6.3,8,6.12Q8,4.232,8,2.344a.565.565,0,0,0-.625-.623c-1.671,0-3.341.007-5.012-.005a.607.607,0,0,0-.656.652c.014,1.25,0,2.5.005,3.749,0,.187.009.2.2.2H4.854m2.014,1.73h-4v3.423h4Z",
    transform: "translate(0 0)",
    fill: "#414042"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtIcon);
export default __webpack_public_path__ + "static/media/WtIcon.ff6ba297d7d885ed6ca7b78fe46acf5f.svg";
export { ForwardRef as ReactComponent };